module.exports = __webpack_public_path__ + "static/img/gif-jiaoyu.fa5b7a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/gif-jiaoyu.jpg
// module id = vzo0
// module chunks = 1